export const ADD_ITEM_TO_CART = 'ADD_ITEM_TO_CART';
export const REMOVE_ITEM_FROM_CART = 'REMOVE_ITEM_FROM_CART';
export const ADD_ITEM_TO_CART_SUCCESS = 'ADD_ITEM_TO_CART_SUCCESS';

export const REMOVE_ITEM_FROM_CART_SUCCESS = 'REMOVE_ITEM_FROM_CART_SUCCESS';
export const ADD_ITEM_TO_CART_FAIL = 'ADD_ITEM_TO_CART_FAIL';
export const REMOVE_ITEM_FROM_CART_FAIL = 'REMOVE_ITEM_FROM_CART_FALI';

export const CART_LIST_REQUEST = 'CART_LIST_REQUEST';
export const CART_LIST_SUCCESS = 'CART_LIST_SUCCESS';
export const CART_LIST_FAIL = 'CART_LIST_FAIL';

export const INCREMENT = 'INCREMENT';
export const DECREMENT = 'DECREMENT';

export const SUBTOTAL = 'SUBTOTAL';
export const STORESUBTOTAL = 'STORESUBTOTAL';

export const GET_COUPON_REQUEST = 'GET_COUPON_REQUEST';
export const GET_COUPON_SUCCESS = 'GET_COUPON_SUCCESS';
export const GET_COUPON_FAIL = 'GET_COUPON_FAIL';

export const SET_COUPON_REQUEST = 'SET_COUPON_REQUEST';
export const SET_COUPON_SUCCESS = 'SET_COUPON_SUCCESS';
export const SET_COUPON_FAIL = 'SET_COUPON_FAIL';


export const GET_TAX_REQUEST='GET_TAX_REQUEST';
export const GET_TAX_SUCCESS='GET_TAX_SUCCESS';
export const GET_TAX_FAIL='GET_TAX_FAIL';
